import { Conversacion } from "@/componentes/buzon/Conversacion"

/** Buzón visto por el personal: todas las conversaciones con los importadores. */
export function Buzon() {
  return (
    <Conversacion
      titulo="Buzón"
      subtitulo="Conversaciones con los importadores, la más reciente primero"
    />
  )
}
